export enum AdobeEventType {
  PAGE_ENTERED = "page_entered",
  VARIANT = "variant",
}
